<template>
    <div class="non-legacy-invoices-modal__overlay" @click.self="!isSaving && $emit('close')">
        <div class="non-legacy-invoices-modal__container bg-lightest py-3 px-4">
            
            <div class="text-center fs-larger font-weight-600 pb-2 dark-top">
                Non Legacy Invoices
            </div>

            <hr class="non-legacy-invoices-modal__divider">

            <div class="non-legacy-invoices-modal__body p-4">
                <label class="full">
                    Payment
                    <div class="mt-2">
                        <v-select
                            :options="paymentOptions"
                            :searchable="false"
                            :disabled="isSaving"
                            label="label"
                            placeholder="Select a payment"
                            v-model="selectedPayment"
                            @input="onPaymentSelected"
                        />
                    </div>
                </label>
            </div>

            <hr class="non-legacy-invoices-modal__divider">

            <div class="d-flex justify-content-end mt-4">
                <button class="btn tertiary mr-2" :disabled="isSaving" @click="$emit('close')">Cancel</button>
                <loading-button
                    class="btn blue"
                    :disabled="!selectedPayment"
                    :loading="isSaving"
                    @click="onSave"
                >
                    Save
                </loading-button>
            </div>
        </div>
    </div>
</template>

<script>
import { reservationsMixin } from '@/mixins/reservations'
import extendedVSelect from '@/extends/vue-select'
import LoadingButton from '@/tools/buttons/LoadingButton'

export default {
    mixins: [reservationsMixin],
    props: {
        payments: {
            type: Array,
            default: () => []
        },
        isSaving: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            selectedPayment: null,
        }
    },
    computed: {
        paymentOptions() {
            return this.payments.map(p => ({
                label: `${p.date} — ${this.formatPrice(p.paidValue)}€`,
                id: p.id,
            }))
        },
    },
    methods: {
        onPaymentSelected(option) {
            if (!option) return
            this.$emit('selected', option.id)
        },
        onSave() {
            if (!this.selectedPayment) return
            this.$emit('save', this.selectedPayment.id)
        },
    },
    components: {
        vSelect: extendedVSelect,
        LoadingButton,
    },
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/_variables.scss';

.non-legacy-invoices-modal {
    &__overlay {
        background-color: rgba(0, 0, 0, 0.5);
        width: 100%;
        height: 100%;
        z-index: 20;
        position: fixed;
        top: 0;
        left: 0;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    &__container {
        width: 40rem;
        max-height: 90%;
        max-width: 100%;
        overflow-y: auto;
        border-radius: 0.25rem;
        position: relative;
    }

    &__divider {
        border-top: 0.0625rem solid $medium;
        margin: 1rem 0;
    }

    &__body {
        min-height: 12rem;
    }
}
</style>


// WEBPACK FOOTER //
// NonLegacyInvoicesModal.vue?7665ff8b